import { render, staticRenderFns } from "./static-navigation-slide.vue?vue&type=template&id=15d75a8c&"
import script from "./static-navigation-slide.vue?vue&type=script&lang=js&"
export * from "./static-navigation-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports